<template>
    <aside class="row">
        <section class="col-xs-12 col-sm-5">
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.directSells"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <input type="number" placeholder="Ex: 100"
                               @keydown.enter.prevent="focusTo('inputAffiliateLicenses')"
                               v-model="directSells"
                        >
                    </div>
                </div>
            </div>
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.affiliateLicenses"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <input type="number" placeholder="Ex: 30"
                               ref="inputAffiliateLicenses"
                               @focus="$event.target.select()"
                               @keydown.enter.prevent="focusTo('inputAffiliateSells')"
                               :disabled="directSells <= 0"
                               v-model="affiliateLicenses"
                        >
                    </div>
                </div>
            </div>
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.affiliateSells"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <input type="number" placeholder="Ex: 5"
                               ref="inputAffiliateSells"
                               @focus="$event.target.select()"
                               @keydown.enter.prevent
                               :disabled="affiliateLicenses <= 0"
                               v-model="affiliateSells"
                        >
                    </div>
                </div>
            </div>
        </section>
        <section class="col-xs-12 col-sm-2">
            <div class="element__section--second__line"></div>
        </section>
        <section class="col-xs-12 col-sm-5">
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.imediate"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <span class="element__father--span__value green-text" v-html="formatMoney(imediateEarnings)"></span>
                    </div>
                </div>
            </div>
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.monthly"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <span class="element__father--span__value green-text" v-html="formatMoney(monthlyEarnings)"></span>
                    </div>
                </div>
            </div>
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.totalDirect"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <span class="element__father--span__value grey-text" v-text="totalDirectClients"></span>
                    </div>
                </div>
            </div>
            <div class="element__father__section col-xs-12">
                <div class="row middle-xs">
                    <div class="col-xs-12 col-lg-6">
                        <span v-text="translations.total2ndTier"></span>
                    </div>
                    <div class="col-xs-12 col-lg-6 margin-top-xs-large">
                        <span class="element__father--span__value grey-text" v-text="total2ndTierClients"></span>
                    </div>
                </div>
            </div>
        </section>

    </aside>
</template>

<script>
  import merge from 'lodash-es/merge';

  export default {
    name: 'ba-new-calculator',
    props: ['calcData'],


    data() {
      return {
        directSells: null,
        affiliateLicenses: null,
        affiliateSells: null,
        defaultData: {
          commercialPlan: 49.9,
          inicialCommission: 1, // 100%
          monthlyComission: 0.3, // 30%
          currency: '$',
          translations: {
            title: "Builderall's 2 Tier License Earnings Calculator",
            directSells: "How many licenses can you sell in one year?",
            affiliateLicenses: "How many will work as an affiliate?",
            affiliateSells: "How many sells each affiliate will make?",
            imediate: "Your immediate earnings",
            monthly: "Your monthly income",
            totalDirect: "Total direct clients",
            total2ndTier: "Total 2nd tier clients"
          }
        }
      }
    },


    computed: {
      translations() {
        return this.defaultData.translations;
      },


      imediateEarnings() {
        //= B1 * B11
        return this.totalDirectClients * this.defaultData.commercialPlan;
      },

      monthlyEarnings() {
        //=0.3*B11*B8 + 0.3*B11*B9
        return this.defaultData.monthlyComission * this.defaultData.commercialPlan * this.totalDirectClients
          + this.defaultData.monthlyComission * this.defaultData.commercialPlan * this.total2ndTierClients;
      },

      totalDirectClients() {
        if (!this.directSells || isNaN(this.directSells)) return 0;

        return parseInt(this.directSells + "").toFixed(0);
      },

      total2ndTierClients() {
        let total = this.affiliateLicenses * this.affiliateSells;
        if (!total || isNaN(total)) return 0;

        return parseInt(total + "").toFixed(0);
      }
    },

    watch: {
      affiliateLicenses(value) {
         this.affiliateLicenses = parseInt(value) > parseInt(this.directSells) ? this.directSells : value;
      }
    },

    methods: {
      formatMoney(n) {
        return this.defaultData.currency + "&nbsp;" + n.toFixed(2).replace(/,/g, function (c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
        });
      },

      formatInteger(str) {
        let inteiro = parseInt(str + "");
        if (inteiro > 100) return 100;
        if (!inteiro || isNaN(inteiro) || inteiro < 0) return 0;

        return inteiro;
      },

      focusTo(name) {
        this.$refs[name].focus();
      }
    },


    created() {
      let globalData = null;
      if (typeof window.calculator !== "undefined") {
        globalData = window.calculator;
      }
      if (this.calcData) {
        globalData = this.calcData;
      }
      if (globalData) {
        this.defaultData = merge(this.defaultData, globalData);
      }

    }
  }
</script>


// WEBPACK FOOTER //
// resources/office/js/components/CalculatorV3.vue